import { Card } from "components/Card/Card";
import { Icon } from "components/Icon/Icon";
import { Link } from "react-router-dom";
import styled from "styled-components/macro";
import { Heading5 } from "styles/elements/Headings";
import { media } from "styles/media";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

interface StyleCardProps extends Props {
  dataCy: string;
}

export const StyleCardContainer = styled.div<Props>`
    cursor: pointer;
    margin: 10px 10px;
    width: 31%;
  ${media.laptop} {
    cursor: pointer;
    margin: 10px 25px;
    width: 42%;
  }
  ${media.tablet} {
    display: flex;
    margin: 12px auto;
    position: relative;
    width: 90%;
  }
`;

export const StyleCard = styled(Card)<StyleCardProps>`
  display: flex;
  flex-direction: column;
  text-align: left;
  position: relative;
  border-radius: 4px;
`;

export const StyleCardImage = styled.div<Props>`
  width: auto;
  height: 153px;
  border-radius: 4px;
`;

export const StyleImage = styled.img<Props>`
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

export const StyleCardContentContainer = styled.div<Props>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const StyleCardContent = styled.div<Props>`
  padding: 18px 24px 15px;
`;

export const StyleTitle = styled.h3<Props>`
  font-size: ${(props: Props) => props.theme.font.size._18};
  font-weight: 700;
  height: 52px;
  margin-bottom: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
`;

export const StyleAuthor = styled(Heading5)`
  margin-bottom: 0;
  line-height: 21px;
`;

export const StyleContentItem = styled.div`
  font-size: ${(props: Props) => props.theme.font.size._14};
  color: ${(props: Props) => props.theme.palette.neutral.black};
  line-height: 21px;
  display: flex;
`;

export const StyleSpan = styled.span<Props>`
  color: ${(props: Props) => props.theme.palette.neutral._80};
`;

export const StyleLink = styled(Link)`
  text-decoration: none;
`;

export const StyleCircleIcon = styled.div`
  i {
  font-size: ${(props: Props) => props.theme.font.size._32};
  }
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  margin-top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: ${(props: Props) => props.theme.palette.neutral.white};
  box-shadow: 0 0 8px rgba(70, 82, 129, 0.13);
  z-index: 10;
`;

export const StyleIcon = styled(Icon)`
  ::before {
    color: ${(props: Props) => props.theme.palette.secondary._900};
  }
`;
